









import { computed, defineComponent } from '@vue/composition-api';
import { useWorkFlow } from '../composables/useWorkFlow';

export default defineComponent({
  name: 'WorkflowTransform',

  setup() {
    const { viewport, fitViewOnInit, fitViewOnInitDone } = useWorkFlow();

    const isHidden = computed(() => {
      if (fitViewOnInit.value) {
        return !fitViewOnInitDone.value;
      }

      return false;
    });

    const transform = computed(
      () =>
        `translate(${viewport.value.x}px,${viewport.value.y}px) scale(${viewport.value.zoom})`
    );

    return { transform, isHidden };
  }
});
